module.exports = __webpack_public_path__ + "img/coaching_1.9f8a1a55.png";